<h3 class="text-center" mat-dialog-title>{{ 'Intellitrailer.Booking.Dialog.swapConfirmation.TitleSwapConfirm' | translate : 'Change trailer'}}</h3>
<div mat-dialog-content>

  <p> {{ 'Intellitrailer.Booking.Dialog.swapConfirmation.txtAreYouSure' | translate : ' Are you sure you want to change your trailer?'}}</p>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'Intellitrailer.Booking.Dialog.swapConfirmation.lblReason' | translate : 'Reason'}}</mat-label>
    <textarea matInput [formControl]="reason"></textarea>
    <mat-error *ngIf="reason.hasError('required')">{{ 'Intellitrailer.Booking.Dialog.swapConfirmation.errorRequired' | translate : 'Reason is required.'}} </mat-error>
    <mat-error *ngIf="reason.hasError('minlength')">{{ 'Intellitrailer.Booking.Dialog.swapConfirmation.ErrorMinCharacters' | translate : 'Please enter at least 6 characters.'}}</mat-error>
  </mat-form-field>

</div>
<div mat-dialog-actions class="btn-container">
  <button mat-button mat-raised-button color="primary" [disabled]="reason.invalid" (click)="confirm()">{{ 'Intellitrailer.Booking.Dialog.swapConfirmation.btnConfirm' | translate : 'Confirm'}}</button>
  <button mat-button mat-raised-button color="accent" (click)="closeDialog()">{{ 'Intellitrailer.Booking.Dialog.swapConfirmation.btnCancel' | translate : 'Cancel'}}</button>
</div>

